import React, { Component } from 'react';

import { HashRouter as Router, Route } from 'react-router-dom'
import { Provider } from 'mobx-react';

import store from '../store';
import shopStore from '../stores/shopStore';
import KabbalahoneView from '../views/KabbalahoneView';

class KabbalahoneApp extends Component {

	constructor(props) {
		super();
		const context = window.tkcWidgetContext;
		store.netsuiteBaseUrl = context.netsuiteBaseUrl;
		store.guestSessionMode = true;		 
		if (context.billingInfo) {
			shopStore.billingInfo.replace(context.billingInfo);
		}					
		shopStore.docebo.set('enroll', context.enrollInDocebo);
		shopStore.setCart(context.skus, context.coupon);
		shopStore.enableCoupons = true;
	}

  	render() {	
		return (
			<Provider store={store} shopStore={shopStore}>          
				<Router>
					<span className="tkc-widget-container">                              
						<Route path="/" component={KabbalahoneView} /> 
					</span>
				</Router>          
			</Provider>
		);
		
  	}

}

export default KabbalahoneApp;



// WEBPACK FOOTER //
// ./src/apps/KabbalahoneApp.js